import React, { useEffect } from "react";
import classes from "./Contacts.module.scss";
import noise from "../../media/noise.png";
import bg from "../../media/background.svg";
import bg768 from "../../media/background-768.svg";
import bg1100 from "../../media/background-1100.svg";
import OurOffice from "./OurOffice.tsx";
import FormCard from "../../components/formCard/FormCard.tsx";
import {Link} from "react-scroll";
import { useTranslation } from "react-i18next";

const Contacts = () => {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
      <main>
        <section className={classes.heading} id="nav-dark">
          <img alt="" className={classes.background} src={bg}/>
          <img alt="" className={classes['background-768']} src={bg768}/>
          <img alt="" className={classes['background-1100']} src={bg1100}/>
          <img alt="" className={classes.noise} src={noise}/>

          <div className={classes.content}
          >
            <div className={classes.text}>
              <h1>{t('contacts.title')}</h1>
              <p>{t('contacts.text')}</p>
              {/*todo add onClick*/}
              <Link to={"contact"} smooth={true}><span>{t('contacts.button')}</span></Link>
            </div>
          </div>
        </section>

        <section className="section--white" id="nav-dark">
          <OurOffice/>
          <FormCard/>
        </section>
      </main>
  );
};

export default Contacts;
